/* src/components/Footer.module.css */
.footer {
  background: var(--dark2);
  border-top: 1px solid var(--border);
  padding: 5rem 0 2rem;
}
.grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem; margin-bottom: 4rem;
}
.brand p { color: var(--muted); font-size: 14px; margin-top: 1rem; max-width: 280px; line-height: 1.7; }
.logoText { font-size: 28px; margin-bottom: 0.5rem; display: block; }
.socials { display: flex; gap: 1rem; margin-top: 1.5rem; font-size: 20px; }
.social { color: var(--muted); transition: color var(--transition); text-decoration: none; }
.social:hover { color: var(--blue-light); }

.col {}
.colTitle {
  font-family: 'Syne', sans-serif; font-size: 13px; font-weight: 700;
  letter-spacing: 1px; text-transform: uppercase;
  color: var(--text); margin-bottom: 1.2rem;
}
.colList { list-style: none; display: flex; flex-direction: column; gap: 0.7rem; }
.colList li { color: var(--muted); font-size: 14px; }
.colList a { color: var(--muted); text-decoration: none; transition: color var(--transition); }
.colList a:hover { color: var(--blue-light); }

.bottom {
  border-top: 1px solid var(--border); padding-top: 2rem;
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem;
}
.bottom p { font-size: 13px; color: var(--muted2); }
.bottom strong { color: var(--muted); }

@media (max-width: 900px) {
  .grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .grid { grid-template-columns: 1fr; }
  .bottom { flex-direction: column; text-align: center; }
}
